module.exports = __webpack_public_path__ + "img/webinar-pana.80a1da4b.svg";